import { createAuthClient } from "better-auth/react";
import { envClient } from "@/lib/config/env.client";

export const authClient = createAuthClient({
  baseURL: envClient.NEXT_PUBLIC_SITE_URL,
});

export const { signIn, signUp, signOut, useSession } = authClient;
